
import { useContext, useEffect, useMemo, useState } from "react";
import { DebouncedInput } from "../../../components_new/debounce-input/debounce-input";
import { Button } from "react-bootstrap";
import { ReportingContext } from "../../home/home";
import { PERMISSIONS } from "../../../common/constants";
import { Can } from "../../../components_new/permission/can";

export const LabelGroups = ({ onChangeFilter, showModal, setShowModal, optionsWorksTag, DashboardContext }) => {
    const { setFilteredReportings, reportings, listFilterTagsReport, setFilterTagsReport } = useContext(DashboardContext);
    const [listFilterValue, setListFilterValue] = useState("");
    const [filteredLabels, setFilteredLabels] = useState(optionsWorksTag);
    const filterReportings = (labelObject) => {

        const newArray = listFilterTagsReport


        const index = newArray.indexOf(labelObject.name);

        if (index > -1) {
            newArray.splice(index, 1); // Remove 1 element at the found index
        }
        else {

            newArray.push(labelObject.name)

        }

        setFilterTagsReport(newArray)



        let newReportings;
        if (!labelObject || !labelObject?.name || labelObject.name === "") {
            newReportings = reportings;
        } else {

            newReportings = reportings.filter(obj => {

                return obj.tags.some(item => listFilterTagsReport.includes(item.tag_name));
            });
        }

        if (listFilterTagsReport.length === 0) {
            newReportings = reportings
        }
        setFilteredReportings(newReportings);
    };

    useEffect(() => {
        if (!listFilterValue || listFilterValue === "" || !optionsWorksTag) {
            setFilteredLabels(optionsWorksTag);
            return;
        }
        const temp = listFilterValue.toLowerCase();
        setFilteredLabels(() => optionsWorksTag.filter((l) => l.name.toLowerCase().includes(temp)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listFilterValue]);

    return (
        <div className="labelGroupBox">
            <div>
                <DebouncedInput placeholder={`🔍Filter Tags`} onChange={setListFilterValue} value={listFilterValue} />
            </div>
            <div  >
                <LabelList DashboardContext={DashboardContext} labels={filteredLabels} listFilterTagsReport={listFilterTagsReport} onClickBox={(l) => filterReportings(l)} showModal={showModal} setShowModal={setShowModal} />
            </div>
        </div>
    );
};

const LabelList = ({ labels, onClickBox, listFilterTagsReport, setShowModal, DashboardContext }) => {
    const [isHovering, setIsHovering] = useState(false);
    const { getWorkSpacePermissions } = useContext(ReportingContext);

    const hoverStyle = {
        backgroundColor: isHovering ? "#3E66FB" : "transparent",
        color: isHovering ? "white" : "#3E66FB",
        border: "1px solid #3E66FB",
        borderRadius: '10px',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.05)'
    };

    const LABELS = useMemo(() => {
        if (!labels || labels.length === +0) {
            return <></>;
        }
        return labels.map((l, idx) => <LabelColorBox DashboardContext={DashboardContext} listFilterTagsReport={listFilterTagsReport} onClickBox={() => onClickBox(l)} label={l.name} color={l.color} key={`${l.text}-${idx}`} />);
    }, [labels]);

    return (<>
        <br></br>
        <Can userRoles={getWorkSpacePermissions()} requiredRoles={[PERMISSIONS["EDIT_TAG"],PERMISSIONS["ADD_TAG"]]}>
        <Button key={"button"} variant="outline-primary"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            style={hoverStyle}
            onClick={() => setShowModal(true)}
        >
            📝  Edit Tags
        </Button>
        </Can>
        {LABELS}

    </>);
};

const LabelColorBox = ({ label, color, onClickBox, DashboardContext }) => {
    const { listFilterTagsReport } = useContext(DashboardContext);

    return (
        <div style={{ paddingTop: "5px" }}>

            <div key={color + label}
                onMouseOver={(e) => e.target.style.cursor = 'pointer'}
                style={{ backgroundColor: listFilterTagsReport.includes(label) ? "#3E66FB" : "white", borderRadius: "5px", padding: "5px", borderColor: "transparent", borderBottom: '1px solid rgba(158, 158, 158, 0.1)', boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.05)' }}>
                <div style={{ padding: "3px", display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: "center", gap: "0.5rem" }} onClick={onClickBox}>


                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                        <span style={{ paddingRight: "5px", width: "0.8rem", height: "0.8rem", borderRadius: '50%', backgroundColor: color }}></span>
                        <b style={{ paddingLeft: "5px", color: listFilterTagsReport.includes(label) ? "white" : "#807f7e" }}>
                            {label}
                        </b>
                    </div>

                    <div >
                        {listFilterTagsReport.includes(label) ? <span style={{ color: "#3E66FB", backgroundColor: "white", borderRadius: "50px" }} class="material-symbols-outlined">
                            cancel
                        </span> : <></>}</div>

                </div>

            </div>

        </div>
    );
};
